import React__default, { useEffect } from 'react';
import ReactDOM__default from 'react-dom';
import { getPortalDOM } from '../Utils/portaldom.util.js';

function FloatingStack(_a) {
    var children = _a.children, order = _a.order, _b = _a.variant, variant = _b === void 0 ? 'bottom' : _b;
    var _c = React__default.useState(null), portalState = _c[0], setPortalState = _c[1];
    var onRefUpdate = function (ref) {
        if (ref && order) {
            ref.setAttribute('data-order', order.toString());
        }
    };
    useEffect(function () {
        setPortalState(getPortalDOM("floating-stack-".concat(variant)));
    }, []);
    useEffect(function () {
        if (portalState) {
            // sort the children based on order
            var children_1 = Array.from(portalState.children);
            children_1.sort(function (a, b) {
                var aOrder = parseInt(a.getAttribute('data-order') || '0', 10);
                var bOrder = parseInt(b.getAttribute('data-order') || '0', 10);
                return bOrder - aOrder;
            });
            children_1.forEach(function (child) {
                portalState.appendChild(child);
            });
        }
    }, [portalState, children]);
    return (React__default.createElement(React__default.Fragment, null, portalState && (React__default.createElement(DOMPortal, { children: children, portalState: portalState, onRefUpdate: onRefUpdate }))));
}
function DOMPortal(_a) {
    var children = _a.children, portalState = _a.portalState, onRefUpdate = _a.onRefUpdate;
    var childRef = React__default.useRef(null);
    useEffect(function () {
        onRefUpdate(childRef.current);
    }, [childRef.current]);
    return ReactDOM__default.createPortal(React__default.createElement("div", { ref: childRef, className: "floating-stack-fw" }, children), portalState);
}

export { FloatingStack as default };
//# sourceMappingURL=FloatingStack.js.map
